import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Redirect } from 'react-router';
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import Button from "app/components/CustomButtons/Button.js";
import Card from "app/components/Card/Card.js";
import CardHeader from "app/components/Card/CardHeader.js";
import CardBody from "app/components/Card/CardBody.js";
import CardFooter from "app/components/Card/CardFooter.js";
import axios from 'axios';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from "app/components/Snackbar/Snackbar.js";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import Typography from '@mui/material/Typography';
import { LoginStatusContext } from "app/context/LoginStatusContext";

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
    },
    colour: {
        backgroundColor: "#5DC0E7"
    }
};

export default function NotificationSettings() {
    const useStyles = makeStyles(styles);
    const [loading, setLoading] = useState(true);
    const [notificationTypes, setNotificationTypes] = useState([]);
    const [pendingSave, setPendingSave] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const { setIsLoggedIn } = useContext(LoginStatusContext);
    
    useEffect(() => {
        async function validateUserSessionId() {
            try {
                await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/login/ValidateUserSessionId`)
                        .then(() => setIsLoggedIn(true));
                
            } catch (error) {
                setIsLoggedIn(false);
                window.location.replace(`${process.env.PUBLIC_URL}/login`);
            }
        }
        validateUserSessionId();
    }, [setIsLoggedIn]);

    useEffect(() => {
        getNotificationTypes();
    }, []);

    async function getNotificationTypes() {
        return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/notification`)
            .then((response) => {
                setNotificationTypes(response.data);
                setLoading(false);
            });
    }

    const ETAOnChange = (event) => {
        if (event.target.value) {
            var newNotificationTypes = [...notificationTypes];

            var notificationType = newNotificationTypes.filter((newNotificationType) => {
                return newNotificationType.notificationTypeId === 26;
            })[0];

            if (notificationType) {
                notificationType.notificationSettings.changeToETA = event.target.value;
                setNotificationTypes(newNotificationTypes);
            }
        }
    }

    const ETDOnChange = (event) => {
        if (event.target.value) {
            var newNotificationTypes = [...notificationTypes];

            var notificationType = newNotificationTypes.filter((newNotificationType) => {
                return newNotificationType.notificationTypeId === 27;
            })[0];

            if (notificationType) {
                notificationType.notificationSettings.changeToETD = event.target.value;
                setNotificationTypes(newNotificationTypes);
            }
        }
    }

    const disableNotifications = (notificationSetting, isActive) => {
        if (isActive) {
            switch (notificationSetting) {
                case 25:
                case 26:
                case 27:
                case 29:
                    return true;
                default:
            }
        }   
    }

    const renderFormUserNotificationTypes = (notificationTypes) => {

        if (notificationTypes === null) {
            return;
        }
        return (
            <CardBody>
                <div class="row">
                    <div class="col-sm-10">
                        <Typography variant="h6" gutterBottom component="div">
                            Notifications
                        </Typography>
                        {notificationTypes.map(notificationType =>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={7}>
                                    <FormControlLabel
                                        label={notificationType.notificationType}
                                        control={<Checkbox checked={notificationType.isActive} disabled={disableNotifications(notificationType.notificationTypeId, notificationType.isActive)} onChange={() => toggleIsActive(notificationType.notificationTypeId)} name="cbNotificationType" id="cbNotificationType" />}
                                    />
                                </GridItem>
                                {notificationType.notificationTypeId === 26 && (<FormControl>
                                    <InputLabel id="changetothebookingeta">Delay (Hours)</InputLabel>
                                    <Select
                                        size="small"
                                        required
                                        labelId="changetothebookingeta"
                                        id="changetothebookingeta"
                                        value={notificationType.notificationSettings.changeToETA}
                                        label="Time (hours)"
                                        sx={{ marginTop: 1, width: 100, height: 20 }}
                                        onChange={ETAOnChange}>
                                        <MenuItem value={24}>24</MenuItem>
                                        <MenuItem value={48}>48</MenuItem>
                                        <MenuItem value={72}>72</MenuItem>
                                        <MenuItem value={96}>96</MenuItem>
                                        <MenuItem value={120}>120</MenuItem>
                                    </Select>
                                </FormControl>)}
                                {notificationType.notificationTypeId === 27 && (<FormControl>
                                    <InputLabel id="changetothebookingetd">Delay (Hours)</InputLabel>
                                    <Select
                                        size="small"
                                        required
                                        labelId="changetothebookingetd"
                                        id="changetothebookingetd"
                                        value={notificationType.notificationSettings.changeToETD}
                                        label="Time (hours)"
                                        sx={{ marginTop: 1, width: 100, height: 20 }}
                                        onChange={ETDOnChange}>
                                        <MenuItem value={24}>24</MenuItem>
                                        <MenuItem value={48}>48</MenuItem>
                                        <MenuItem value={72}>72</MenuItem>
                                        <MenuItem value={96}>96</MenuItem>
                                        <MenuItem value={120}>120</MenuItem>
                                    </Select>
                                </FormControl>)}
                            </GridContainer>
                        )}
                    </div>
                    <div class="col-sm-2">
                        <Typography variant="h6" gutterBottom component="div">
                            Email
                        </Typography>
                        {notificationTypes.map(notificationType =>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={7}>
                                    <FormControlLabel
                                        control={<Checkbox checked={notificationType.isEmail} disabled={!notificationType.isActive} onChange={() => toggleIsEmail(notificationType.notificationTypeId)} name="cbNotificationTypeEmail" id="cbNotificationTypeEmail" />}
                                    />
                                </GridItem>
                            </GridContainer>
                        )}
                    </div>
                </div>

            </CardBody>
        );
    }

    const toggleIsActive = (notificationTypeId) => {
        if (notificationTypes === null) {
            return;
        }
        let newNotificationTypes = [...notificationTypes];
        let index = newNotificationTypes.findIndex((notificationType) => {
            return notificationType.notificationTypeId === notificationTypeId;
        });

        newNotificationTypes[index].isActive = !newNotificationTypes[index].isActive;

        if (!newNotificationTypes[index].isActive) {
            newNotificationTypes[index].isEmail = false;
        }

        setNotificationTypes(newNotificationTypes);
    }

    const toggleIsEmail = (notificationTypeId) => {
        if (notificationTypes === null) {
            return;
        }
        let newNotificationTypes = [...notificationTypes];
        let index = newNotificationTypes.findIndex((notificationType) => {
            return notificationType.notificationTypeId === notificationTypeId;
        });

        newNotificationTypes[index].isEmail = !newNotificationTypes[index].isEmail;

        setNotificationTypes(newNotificationTypes);
    }

    const onNotificationTypesSubmit = (e) => {
        setPendingSave(true);
        e.preventDefault();
        const formDataJsonString = JSON.stringify(notificationTypes);
        axios
            .post(
                `${process.env.REACT_APP_API_ENDPOINT}/api/notification`,
                formDataJsonString
            )
            .then(function (response) {
                if (response.data === "Updated") {
                    setSuccess(true);
                    setError(false);

                    setTimeout(() => {
                        setSuccess(false)
                    }, 5000)

                    getNotificationTypes();
                }
                else {
                    setError(true);
                    setSuccess(false);

                    setTimeout(() => {
                        setError(false)
                    }, 5000)
                }

                setPendingSave(false);
            })
            .catch(function (error) {
                setError(true);
                setSuccess(false);

                setTimeout(() => {
                    setError(false)
                }, 5000)

                setPendingSave(false);
            });
    };

    let NotificationTypeContents = loading
        ? <em>Loading...</em>
        : renderFormUserNotificationTypes(notificationTypes);

    const classes = useStyles();

    return (
        <div style={{ position: 'relative', zIndex: '0' }}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader className={classes.colour}>
                            <h4 className={classes.cardTitleWhite}>Notification Types</h4>
                            <p className={classes.cardCategoryWhite}>Update which notifications to display</p>
                        </CardHeader>
                        <form onSubmit={onNotificationTypesSubmit}>
                            {NotificationTypeContents}
                            <Snackbar place="br" color="success" icon={CheckCircleIcon} message="Notifications successfully updated!" open={success}
                                closeNotification={() => setSuccess(false)} close />
                            <Snackbar place="br" color="danger" icon={ErrorIcon} message="Notifications failed to update!" open={error}
                                closeNotification={() => setError(false)} close />
                            <CardFooter>
                                <Button className={classes.colour} disabled={pendingSave} type="submit">Save</Button>
                                {pendingSave && (<CircularProgress style={{ position: 'absolute', marginLeft: 25, color: '#FFF' }}></CircularProgress>)}
                            </CardFooter>
                        </form>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}
